// Partner visits API (2026-10-06): see docs/superpowers/specs/2026-10-06-partner-visits-api-design.md

import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import { route } from 'preact-router';
import Markdown from 'preact-markdown';

import versionData from '../../version.json';
import MenuColorLegend from './colorLegend';

import MenuList from './list';

import localUtil from '../../lib/util';
import reloadAppHelper from '../../lib/reloadApp';
import lockScreenStore from '../../stores/lockScreen';
// Tilleggsmodul (C) and signing/NDA (B✕) menu entries come from the product
// registries as factories; the Dyrejournal-repo export stubs the registries,
// otherMenu()/signingMenu() then return null and the .filter(Boolean) on the
// links arrays drops the entries.
import { menuItemsOther } from '../../product/menu-other';
import { menuItemsSigning } from '../../product/menu-signing';
import { animalAge } from '../../lib/animalAge';

function checkForPistolClub(hostname) {
    // !(window.location.hostname === 'dokkapk.no'),
    // Check if hostname equals 'dokkapk.no' or contains 'pistolklubb.app'
    if (hostname === 'dokkapk.no' || hostname.includes('pistolklubb.app')) {
        return true;
    }
    return false;
}


@observer
class Menu extends Component {
	constructor(props) {
        super(props);
        const { appState, userStore } = props.stores;
        const { isDevelopment, opts = {}, currentCustomer = {} } = appState;
        const { customer, user, isAdmin, isCustomerAdmin, isRangeOfficer, hasTvRadioProducerAccess, hasRaceAdminAccess, isRaceSuperAdmin, isBlockedFromSupportTickets } = userStore;
        const { featureFlags = {} } = customer;
        const { isMediaWorker, isSoknadsguideadmin, isApproved, isTicketWorker, isShopWorker, isSupport, isGpsAdmin } = user;
        const otherMenuCtx = { currentCustomer, opts, featureFlags, isApproved, isGpsAdmin, isAdmin, isCustomerAdmin, isRangeOfficer, hasTvRadioProducerAccess, isRaceSuperAdmin };
        const otherMenu = key => (menuItemsOther[key] ? menuItemsOther[key](otherMenuCtx) : null);
        const signingMenuCtx = { user };
        const signingMenu = key => (menuItemsSigning[key] ? menuItemsSigning[key](signingMenuCtx) : null);
        // Opt-out keys on the domain customer (menuItems.hide*): the entry/section is dropped for everyone.
        const hideMenu = currentCustomer.menuItems || {};
        // console.log('currentCustomer:', currentCustomer);
        this.state = {
            menuLinks: [
                {
                    name: <Text id='menu.section-admin'>Admin</Text>,
                    links: [
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.admin'>Admin</Text>,
                            searchText: 'Admin',
                            href: '/admin/user',
                            icon: 'fa-solid fa-user-police',
                            keyShortCut: 'a a',
                        },
                        otherMenu('terrain-model'),
                        otherMenu('newsletter'),
                        otherMenu('admin-imports'),
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.development'>Development</Text>,
                            searchText: 'Development Utvikling',
                            href: '/admin/development',
                            icon: 'fa-solid fa-user-police',
                            keyShortCut: 'a d',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.development-ai'>Development AI</Text>,
                            searchText: 'Development AI Utvikling av AI',
                            href: '/admin/development-ai',
                            icon: 'fa-solid fa-user-police',
                            keyShortCut: 'a d',
                        },
                        otherMenu('refresh-scenes'),
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.errors'>Errors</Text>,
                            searchText: 'Errors Feil',
                            href: '/errors/',
                            icon: 'fa-solid fa-bug',
                            keyShortCut: 'a e',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='oauthClients.title'>OAuth clients</Text>,
                            searchText: 'OAuth clients partner API AI scribe vendor klienter',
                            href: '/admin/oauth-clients',
                            icon: 'fa-solid fa-plug-circle-check',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.dyrejournal-admin'>Dyrejournal Admin</Text>,
                            searchText: 'Dyrejournal Admin',
                            href: '/dyrejournal-admin/',
                            icon: 'fa-solid fa-user-police',
                            keyShortCut: 'd a',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.pistolklubb-admin'>Pistolklubb Admin</Text>,
                            searchText: 'Pistolklubb Admin klubb onboarding skytterklubb',
                            href: '/pistolklubb-admin/',
                            icon: 'fa-solid fa-bullseye-pointer',
                            keyShortCut: 'p a',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.admin-sales'>Admin: All Sales</Text>,
                            searchText: 'Admin All Sales Alt salg',
                            href: '/admin-sales/',
                            icon: 'fa-solid fa-file-invoice-dollar',
                            keyShortCut: 'a s',
                        },
                        otherMenu('admin-trophies'),
                        otherMenu('admin-elearning'),
                        otherMenu('content-curation'),
                        otherMenu('moderation'),
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.image-browser'>Image Browser</Text>,
                            searchText: 'Image Browser images photos Bildebibliotek bilder',
                            href: '/admin/images',
                            icon: 'fa-solid fa-images',
                            keyShortCut: 'a b',
                        },
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.section-statistics'>Statistics</Text>,
                    links: [
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.statistics'>Statistics</Text>,
                            searchText: 'Statistics Statistikk',
                            href: '/statistics/',
                            icon: 'fa-solid fa-line-chart',
                            keyShortCut: 's s',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.usage-stats'>Usage Stats</Text>,
                            searchText: 'Usage Stats Bruksstatistikk',
                            href: '/usage-stats/',
                            icon: 'fa-solid fa-chart-pie',
                            keyShortCut: 'u s',
                        },
                        otherMenu('feed-results'),
                        {
                            hasToBeAdmin: true,
                            name: <Text id='apiKeyUsage.title'>API key usage</Text>,
                            searchText: 'API key token usage bruk nøkler',
                            href: '/admin/api-tokens',
                            icon: 'fa-solid fa-key',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='featureUsage.title'>Online services usage</Text>,
                            searchText: 'feature usage online booking prescription timebestilling reseptbestilling bruk nettjenester',
                            href: '/admin/feature-usage',
                            icon: 'fa-solid fa-chart-column',
                        },
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.section-logs'>Logs</Text>,
                    links: [
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.apilogger'>API logger</Text>,
                            searchText: 'API logger API-logger',
                            href: '/apilogger/',
                            icon: 'fa-solid fa-list',
                            keyShortCut: 'a l',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.querylogger'>Query logger</Text>,
                            searchText: 'Query logger Spørringslogger',
                            href: '/querylogger/',
                            icon: 'fa-solid fa-list',
                            keyShortCut: 'a q',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.smslist'>SMS List</Text>,
                            searchText: 'SMS List SMS liste',
                            href: '/sms/',
                            icon: 'fa-solid fa-list',
                            keyShortCut: 'a s',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.notificationLogs'>Push notification log</Text>,
                            searchText: 'Push notifications log varsler logg',
                            href: '/notification-logs',
                            icon: 'fa-duotone fa-bell-on',
                            keyShortCut: 'a n',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.mailsentlist'>mailsent List</Text>,
                            searchText: 'Mail Sent List postsendt liste e-post',
                            href: '/mailsent/',
                            icon: 'fa-solid fa-list',
                            keyShortCut: 'a m',
                        },
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.main-content'>Main menu</Text>,
                    links: [
                        {
                            name: <Text id='menu.frontpage'>Frontpage</Text>,
                            searchText: 'Frontpage Home Forsiden Hjem',
                            href: '/',
                            icon: 'fa-solid fa-house',
                            keyShortCut: 'g f',
                        },
                        otherMenu('marketplace'),
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.calendar || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.calendar'>Calendar</Text>,
                            searchText: 'Calendar Kalender',
                            href: '/calendar/',
                            icon: 'fa-regular fa-calendar',
                            keyShortCut: 'g c',
                        },
                        otherMenu('courses'),
                        otherMenu('elearning'),
                        otherMenu('shooting-exam'),
                        otherMenu('holiday-planner'),
                        {
                            hasToBeAdmin: !(isApproved && currentCustomer.menuItems?.media ? true : false),
                            name: <Text id='menu.media'>Media</Text>,
                            searchText: 'Media images photos bilder',
                            href: '/media/',
                            icon: 'fa-regular fa-images',
                            keyShortCut: 'm l',
                        },
                        otherMenu('news'),
                        {
                            hasToBeAdmin: !currentCustomer.menuItems?.news,
                            name: <Text id='shorts.tab'>Shorts</Text>,
                            searchText: 'Shorts Snutter portrait video vertical feed reels',
                            href: '/feed/shorts',
                            icon: 'fa-duotone fa-rectangle-vertical',
                        },
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.section-dyrejournal'>Dyrejournal</Text>,
                    links: [
                        {
                            // hasToBeAdmin: !opts.showDyrejournal,
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-clinic'>Dyrejournal - clinic</Text>,
                            searchText: 'Dyrejournal clinic veterinary Klinikk veterinær',
                            href: '/dyrejournal-clinic/',
                            icon: 'fa-regular fa-hospital',
                            keyShortCut: 'd c',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-sale'>Dyrejournal - sale</Text>,
                            searchText: 'Dyrejournal sale Besøk',
                            href: '/dyrejournal-sale/',
                            icon: 'fa-regular fa-calendar',
                            keyShortCut: 'd s',
                        },
                        ((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved && !!user.id) ? {
                            name: <Text id='menu.dyrejournal-contrast'>Dyrejournal - contrast</Text>,
                            searchText: 'Dyrejournal contrast high contrast kontrast høy kontrast tilgjengelighet',
                            icon: 'fa-solid fa-circle-half-stroke',
                            func: () => appState.openDrawerRight('dyrejournalContrast', {
                                height: appState.drawerHeightMedium,
                            }, 2),
                        } : null,
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-products-list'>Dyrejournal - Product list</Text>,
                            searchText: 'Dyrejournal Product list Produktliste',
                            href: '/products/table',
                            icon: 'fa-regular fa-list',
                            keyShortCut: 'p a',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-payments'>Dyrejournal - payments</Text>,
                            searchText: 'Dyrejournal payments Betalinger',
                            href: '/dyrejournal-payments/',
                            icon: 'fa-regular fa-money-bill',
                            keyShortCut: 'd p',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-accounts'>Dyrejournal - chart of accounts</Text>,
                            searchText: 'Dyrejournal chart of accounts kontoplan accounting Tripletex Fiken PowerOffice',
                            href: '/dyrejournal-accounts/',
                            icon: 'fa-duotone fa-list-ol',
                            keyShortCut: 'd a',
                        },
                        {
                            hasToBeAdmin: !(featureFlags.kpiDashboard && (currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-kpi'>Dyrejournal - KPI Dashboard</Text>,
                            searchText: 'Dyrejournal KPI dashboard nøkkeltall statistikk rapport',
                            href: '/dyrejournal-kpi/',
                            icon: 'fa-duotone fa-chart-line',
                            keyShortCut: 'd k',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-sms'>Dyrejournal - SMS list</Text>,
                            searchText: 'Dyrejournal SMS list SMS-liste',
                            href: '/dyrejournal-sms/',
                            icon: 'fa-regular fa-list',
                            keyShortCut: 'd l s',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-sms-reminder-log'>Dyrejournal - SMS reminder log</Text>,
                            searchText: 'Dyrejournal SMS reminder log påminnelse SMS-påminnelse',
                            href: '/dyrejournal-sms-reminder-log',
                            icon: 'fa-regular fa-clock-rotate-left',
                            keyShortCut: 'd l r',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-no-shows'>Dyrejournal - no-shows</Text>,
                            searchText: 'Dyrejournal ikke møtt no-show uteblitt bookinger dukket ikke opp',
                            href: '/dyrejournal-no-shows/',
                            icon: 'fa-duotone fa-person-circle-question',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-mailsent'>Dyrejournal - Mail Sent list</Text>,
                            searchText: 'Dyrejournal Mail Sent list email Sendte E-poster',
                            href: '/dyrejournal-mailsent/',
                            icon: 'fa-regular fa-list',
                            keyShortCut: 'd l m',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-files'>Dyrejournal - Files</Text>,
                            searchText: 'Dyrejournal Files documents Filer dokumenter',
                            href: '/dyrejournal-files/',
                            icon: 'fa-regular fa-files',
                            keyShortCut: 'd f',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-contacts'>Dyrejournal - Contacts</Text>,
                            searchText: 'Dyrejournal Contacts Kontaktliste',
                            href: '/dyrejournal-contacts/',
                            icon: 'fa-regular fa-address-book',
                            keyShortCut: 'd l c',
                        },
                        {
                            hasToBeAdmin: !(featureFlags.idexx && (currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-lab-results'>Lab results</Text>,
                            searchText: 'Lab results IDEXX Labresultater',
                            href: '/dyrejournal-lab-results/',
                            icon: 'fa-solid fa-flask-vial',
                            keyShortCut: 'd l r',
                        },
                        {
                            hasToBeAdmin: !(featureFlags.idexx && isCustomerAdmin && (currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            isRoleLink: true,
                            name: <Text id='menu.dyrejournal-idexx-mapping'>IDEXX mapping</Text>,
                            searchText: 'IDEXX mapping products tests linking',
                            href: '/dyrejournal-idexx-mapping/',
                            icon: 'fa-duotone fa-link',
                            keyShortCut: 'd l m',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.idexx-admin'>IDEXX admin</Text>,
                            searchText: 'IDEXX admin Idexx integration health',
                            href: '/admin/idexx',
                            icon: 'fa-duotone fa-flask-vial',
                        },
                        {
                            hasToBeAdmin: !(featureFlags.phoneConsultations && (currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-phone-consultations'>Dyrejournal - phone consultations</Text>,
                            searchText: 'Dyrejournal phone consultations telefonkonsultasjoner phone call telefon rådgivning',
                            href: '/dyrejournal-phone-consultations/',
                            icon: 'fa-duotone fa-phone-volume',
                            keyShortCut: 'p c',
                        },
                        {
                            hasToBeAdmin: !(featureFlags.onlinePrescriptionOrders && (currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-prescription-orders'>Dyrejournal - prescription orders</Text>,
                            searchText: 'Dyrejournal prescription orders reseptbestillinger resept bestilling online',
                            href: '/dyrejournal-prescription-orders/',
                            icon: 'fa-duotone fa-prescription',
                            keyShortCut: 'p o',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-notifications'>Innkallinger</Text>,
                            searchText: 'Innkallinger notifications cartrophen vaksine reminder',
                            href: '/notifications',
                            icon: 'fa-duotone fa-bell',
                            keyShortCut: 'd n',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.dyrejournal-pending-sales'>Pending sales</Text>,
                            searchText: 'Pending sales offline queue Ventende salg',
                            href: '/dyrejournal-pending-sales/',
                            icon: 'fa-duotone fa-cloud-arrow-up',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.visitors'>Visitors</Text>,
                            searchText: 'Visitors customers Besøkende kunder',
                            href: '/visitor/',
                            icon: 'fa-regular fa-address-book',
                            keyShortCut: 'd l v',
                        },
                        {
                            hasToBeAdmin: !((currentCustomer.menuItems?.dyrejournal || opts.showDyrejournal) && isApproved),
                            name: <Text id='menu.animals'>Animals</Text>,
                            searchText: 'Animals pets Dyr kjæledyr',
                            href: '/animal/',
                            icon: 'fa-regular fa-address-book',
                            keyShortCut: 'd l a',
                        },
                        {
                            hasToBeAdmin: !(opts.showDyrejournal && isApproved),
                            name: <Text id='menu.texttemplates'>Text Templates</Text>,
                            searchText: 'Text Templates messages Tekstmaler meldinger',
                            href: '/texttemplates',
                            icon: 'fa-solid fa-text-size',
                            keyShortCut: 't p',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.product-lists-admin'>Product lists</Text>,
                            searchText: 'product lists varelister supplier leverandor import',
                            href: '/admin/product-lists',
                            icon: 'fa-duotone fa-book',
                        },
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.section-shop'>Shop and products</Text>,
                    links: [
                        {
                            // Race admins handle the orders from their race shop, so they get the
                            // sales list even when the domain customer has not enabled the webshop.
                            hasToBeAdmin: !(isApproved && (currentCustomer.menuItems?.webshop || hasRaceAdminAccess) ? true : false),
                            name: <Text id='menu.sale'>Sale</Text>,
                            searchText: 'Sale shop Salg butikk',
                            href: '/dyrejournal-sale/',
                            icon: 'fa-regular fa-shopping-cart',
                            keyShortCut: 'd s',
                        },
                        {
                            hasToBeAdmin: !(currentCustomer.menuItems?.webshop ? true : false),
                            name: <Text id='menu.webshop'>Webshop</Text>,
                            searchText: 'Webshop store shop Nettbutikk butikk',
                            href: '/products',
                            icon: 'fa-solid fa-box',
                            keyShortCut: 'p w',
                        },
                        {
                            // Race admins manage the products sold in their race shop, so they get
                            // the list even when the domain customer has not enabled it for everyone.
                            hasToBeAdmin: !(isApproved && (currentCustomer.menuItems?.productList || hasRaceAdminAccess) ? true : false),
                            name: <Text id='menu.products-list'>Products list</Text>,
                            searchText: 'Products list inventory Produktliste produkter',
                            href: '/products/table',
                            icon: 'fa-solid fa-box',
                            keyShortCut: 'p l',
                        },
                        {
                            hasToBeAdmin: !(isApproved && currentCustomer.menuItems?.productList ? true : false),
                            name: <Text id='menu.products-qrcode-scanner'>Products QrCode scanner</Text>,
                            searchText: 'Products QrCode scanner Produkter QRCode-skanner',
                            href: '/products/qrcodeScanner',
                            icon: 'fa-solid fa-qrcode',
                            keyShortCut: 'p s',
                        },
                        {
                            hasToBeAdmin: !(isApproved && currentCustomer.menuItems?.productList ? true : false),
                            name: <Text id='menu.products-barcode-scanner'>Products Barcode scanner</Text>,
                            searchText: 'Products Barcode scanner Produkter Strekkodeskanner',
                            href: '/products/barcodeScanner',
                            icon: 'fa-solid fa-barcode',
                            keyShortCut: 'p b',
                        },
                        {
                            hasToBeAdmin: !(isApproved && currentCustomer.menuItems?.productList ? true : false),
                            name: <Text id='sidebar.productImports'>My imports</Text>,
                            searchText: 'import vareliste varer Mine vareimporter',
                            href: '/products/imports',
                            icon: 'fa-duotone fa-file-import',
                            keyShortCut: 'p i',
                        },
                        {
                            hasToBeAdmin: true,
                            name: <Text id='menu.pricelists'>Pricelists</Text>,
                            searchText: 'Prislister pricelists forhandler forhandlerpriser dealer prices',
                            href: '/pricelists',
                            icon: 'fa-duotone fa-tags',
                        },
                        {
                            hasToBeAdmin: !(isApproved && currentCustomer.menuItems?.textTemplates ? true : false),
                            name: <Text id='menu.texttemplates'>Text Templates</Text>,
                            searchText: 'Text Templates messages Tekstmaler meldinger',
                            href: '/texttemplates',
                            icon: 'fa-solid fa-text-size',
                            keyShortCut: 't p',
                        },
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.section-shooting'>Shooting</Text>,
                    links: [
                        otherMenu('shooting-convention'),
                        otherMenu('terminliste'),
                        otherMenu('shooting-rankings'),
                        otherMenu('julekalender'),
                        otherMenu('vapensoknad'),
                        otherMenu('shot-calc'),
                        otherMenu('shot-trainer'),
                        otherMenu('shooting-light'),
                        otherMenu('ballistic-calculator'),
                        otherMenu('lot-testing'),
                        otherMenu('ammo-sales'),
                        otherMenu('club-weapons'),
                        otherMenu('club-ammo'),
                        otherMenu('club-roles'),
                        otherMenu('club-dugnad'),
                        otherMenu('club-advent-calendar'),
                        otherMenu('club-ranges'),
                        otherMenu('club-keys'),
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.section-tools'>Tools</Text>,
                    links: [
                        otherMenu('coffee'),
                        otherMenu('f1'),
                        otherMenu('timetracker'),
                        otherMenu('installations'),
                        otherMenu('parts'),
                        otherMenu('inspections'),
                        otherMenu('work-sharing'),
                        otherMenu('tv-radio-producer'),
                        otherMenu('carpenter-tools'),
                        {
                            hasToBeAdmin: !(isTicketWorker && isApproved),
                            name: <Text id='menu.ticketScanner'>Ticket scanner</Text>,
                            searchText: 'Ticket scanner Billettskanner',
                            href: '/ticketScanner/',
                            icon: 'fa-solid fa-qrcode',
                            keyShortCut: 't s',
                        },
                        otherMenu('admin-checklists'),
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.section-race'>Race</Text>,
                    links: hideMenu.hideRace ? [] : [
                        otherMenu('race'),
                        otherMenu('musher-ranking'),
                        otherMenu('race-results-browser'),
                        otherMenu('gps-tracking'),
                        otherMenu('allgpsdevices'),
                        otherMenu('gpsdevicesavailable'),
                        otherMenu('videostreaming'),
                        otherMenu('admin-race-class-contestants'),
                        otherMenu('admin-race-tracker-calendar'),
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.section-support'>Support</Text>,
                    links: [
                        hideMenu.hideSupport ? null : {
                            hasToBeAdmin: isBlockedFromSupportTickets,
                            name: <Text id='menu.support'>Support</Text>,
                            searchText: 'Support Help Hjelp',
                            href: '/support',
                            icon: 'fa-duotone fa-life-ring',
                            keyShortCut: 'g s',
                        },
                        hideMenu.hideSupport ? null : {
                            hasToBeAdmin: isBlockedFromSupportTickets || !user.id,
                            name: <Text id='menu.refund'>Refund Request</Text>,
                            searchText: 'Refund Request Refusjon',
                            href: '/support/refund',
                            icon: 'fa-solid fa-money-bill-transfer',
                        },
                        {
                            hasToBeAdmin: isBlockedFromSupportTickets || !(isSupport || isAdmin),
                            isRoleLink: true,
                            name: <Text id='menu.support-staff-queue'>Support Staff Queue</Text>,
                            searchText: 'Support Staff Queue Kø for support',
                            href: '/support/staff',
                            icon: 'fa-solid fa-headset',
                            keyShortCut: 's q',
                        },
                        {
                            hasToBeAdmin: !(isSupport || isAdmin),
                            isRoleLink: true,
                            name: <Text id='support.aiFeedback.review-title'>AI Feedback Review</Text>,
                            searchText: 'AI Feedback Review hallucination flag tilbakemelding',
                            href: '/admin/ai-feedback',
                            icon: 'fa-duotone fa-flag',
                        },
                        otherMenu('newsletter-articles'),
                        {
                            hasToBeAdmin: !(currentCustomer.menuItems?.help ? true : false),
                            name: <Text id='menu.help'>Help</Text>,
                            searchText: 'Help documentation Hjelp',
                            func: this.showHelp,
                            icon: 'fa-duotone fa-circle-question',
                            keyShortCut: 'g h',
                        },
                        {
                            // hasToBeAdmin: !checkForPistolClub(window.location.hostname),
                            hasToBeAdmin: !(currentCustomer.menuItems?.gdpr ? true : false),
                            name: <Text id='menu.gdpr'>GDPR</Text>,
                            searchText: 'GDPR privacy data personvern',
                            href: '/gdpr',
                            icon: 'fa-duotone fa-shield-alt',
                            keyShortCut: 'g d',
                        },
                        {
                            hasToBeAdmin: !(currentCustomer.menuItems?.termsOfSale ? true : false),
                            name: <Text id='menu.termsOfSale'>Terms of Sale</Text>,
                            searchText: 'Terms of Sale Salgsbetingelser Salgsvilkår',
                            href: '/terms',
                            icon: 'fa-duotone fa-file-contract',
                            keyShortCut: 'g b',
                        },
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.section-signing'>Signing</Text>,
                    links: hideMenu.hideSigning ? [] : [
                        signingMenu('signing-requests'),
                        signingMenu('signRequest'),
                        signingMenu('nda'),
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.section-profile'>My profile</Text>,
                    links: [
                        {
                            hasToBeAdmin: !(currentCustomer.menuItems?.mypage ? true : false),
                            name: <Text id='menu.my-page'>My page</Text>,
                            searchText: 'My page Profile Min side Profil',
                            href: '/users/profile',
                            icon: 'fa-solid fa-user-vneck',
                            keyShortCut: 'm p',
                        },
                        hideMenu.hideNotifications ? null : {
                            hasToBeAdmin: !user.id,
                            name: <Text id='push.settings.title'>Notifications</Text>,
                            searchText: 'Notifications Push Varsler',
                            href: '/settings/notifications',
                            icon: 'fa-duotone fa-bell',
                        },
                        otherMenu('my-photos'),
                        hideMenu.hideAiConnections ? null : {
                            hasToBeAdmin: !isApproved,
                            name: <Text id='menu.mcp-connections'>AI connections</Text>,
                            searchText: 'AI connections MCP Claude AI-tilkoblinger',
                            href: '/mcp-connections',
                            icon: 'fa-solid fa-plug',
                        },
                        {
                            hasToBeAdmin: !featureFlags?.lockScreen?.enabled,
                            name: <Text id='menu.changePin'>Change PIN</Text>,
                            searchText: 'Change PIN Endre PIN-kode Ny PIN Glemt PIN',
                            href: '/profile/set-pin',
                            icon: 'fa-duotone fa-key',
                        },
                    ].filter(Boolean),
                },
                {
                    name: <Text id='menu.section-account'>Account</Text>,
                    links: [
                        hideMenu.hideOfflinePrepare ? null : {
                            hasToBeAdmin: !isApproved,
                            name: <Text id='menu.prepare-offline'>Forbered for offline</Text>,
                            searchText: 'Prepare for offline Forbered offline-modus',
                            func: () => { require('../../lib/offlinePrefetch').runPrefetch(); },
                            icon: 'fa-solid fa-cloud-arrow-down',
                        },
                        {
                            name: <Text id='menu.reload'>Reload</Text>,
                            searchText: 'Reload refresh Last inn på nytt oppdater',
                            func: this.reloadApp,
                            icon: 'fa-solid fa-arrows-rotate',
                            keyShortCut: 'shift+r',
                        },
                        {
                            hasToBeAdmin: !featureFlags?.lockScreen?.enabled,
                            name: <Text id='menu.lockScreen'>Lock screen</Text>,
                            searchText: 'Lock screen Lås skjerm PIN',
                            func: this.lockScreen,
                            icon: 'fa-duotone fa-lock',
                            keyShortCut: 'g l',
                        },
                        {
                            name: <Text id='menu.logout'>Logout</Text>,
                            searchText: 'Logout sign out Logg ut',
                            href: '/logout',
                            icon: 'fa-solid fa-right-from-bracket',
                            keyShortCut: 'l o',
                        },
                    ].filter(Boolean),
                },
            ],
            menuLinksNotLoggedIn: [
                {
                    name: <Text id='menu.main-content'>Main menu</Text>,
                    // help: <Text id='menu.add-new-content-help'>Choose what kind of content you want to create.</Text>,
                    links: [
                        {
                            name: <Text id='menu.frontpage'>Frontpage</Text>,
                            searchText: 'Frontpage Home Forsiden Hjem',
                            href: '/',
                            icon: 'fa-solid fa-house',
                            keyShortCut: 'g f',
                        },
                        otherMenu('nli-marketplace'),
                        otherMenu('nli-news'),
                        otherMenu('nli-race'),
                        otherMenu('nli-shooting-convention'),
                        otherMenu('nli-shooting-rankings'),
                        otherMenu('nli-vapensoknad'),
                        {
                            name: <Text id='menu.reload'>Reload</Text>,
                            searchText: 'Reload refresh Last inn på nytt oppdater',
                            func: this.reloadApp,
                            icon: 'fa-solid fa-arrows-rotate',
                        },
                        {
                            name: <Text id='menu.login'>Login</Text>,
                            searchText: 'Login sign in Logg inn',
                            func: this.gotoLogin,
                            icon: 'fa-solid fa-right-to-bracket',
                        },
                    ].filter(Boolean),
                },
            ],
        };
    }

    gotoLogin = () => {
        const { appState } = this.props.stores;
        const { path } = appState;
        appState.setWantedPage(path);
        route('/login');
    }

    reloadApp = () => {
        reloadAppHelper();
    }

    lockScreen = () => {
        const { appState } = this.props.stores;
        const { drawerLevel = 1 } = this.props;
        appState.toggleDrawer(false, drawerLevel);
        lockScreenStore.lock();
    }

    showHelp = () => {
        const { drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        const { drawerHeightLarge } = appState;
        appState.toggleDrawer(false, drawerLevel);
        appState.openDrawer('help', {
			height: drawerHeightLarge,
        }, drawerLevel + 1);
    }

    onClickViewAnimal = e => {
        e.stopPropagation();
        e.preventDefault();
        const { id } = e.target.closest('.animal-line').dataset;
        const { drawerLevel = 1 } = this.props;
		const { appState, saleStore, animalStore } = this.props.stores;
		const { drawerHeightLarge } = appState;

		appState.openDrawer('viewAnimal', {
			height: drawerHeightLarge,
            isNew: false,
            hideAdmin: true,
            id: parseInt(id, 10),
            callback: () => {
                // console.log('onClickViewAnimal callback');
                const { animal } = animalStore;
                // A deleted or out-of-scope animal id loads as an empty result,
                // leaving animalStore.animal undefined — nothing to sync back.
                if (!animal || !animal.id) {
                    return;
                }
                const { newSale, visitorAnimals } = saleStore;
                const { animals } = newSale;
                const idx = animals.findIndex(a => a.id === animal.id);
                if (idx > -1) {
                    saleStore.updateObjectKeyArrValue('newSale', 'animals', idx, animal);
                }
                const idx2 = visitorAnimals.findIndex(a => a.id === animal.id);
                if (idx2 > -1) {
                    saleStore.updateKeyArrValue('visitorAnimals', idx2, animal);
                }
            },
		}, drawerLevel + 1);
    }

    selectView = (e) => {
        const { appState } = this.props.stores;
        const { type } = e.target.closest('button').dataset;
        appState.setViewKey('clinic', type);
    }

    toggleAdminFields = () => {
        const { appState } = this.props.stores;
        const { showAdminFields } = appState;
        appState.setShowAdminFields(!showAdminFields);
    }

    loadAll = async () => {
        const { appState, animalStore } = this.props.stores;
        const { isDevelopment, opts = {} } = appState;
        if ((isDevelopment || opts.showDyrejournal)) {
            animalStore.load({ query: { isAdmittedToClinic: true }, addData: ['owners'] });
        }
    }

    onClickChooseCustomer = async e => {
        e.stopPropagation();
        e.preventDefault();
        const { id } = e.target.closest('.customer-line').dataset;
        const { drawerLevel = 1 } = this.props;
        const { appState, userStore, saleStore, journalStore, visitorStore, animalStore, calendarStore } = this.props.stores;

        // Clear store data when switching customers
        if (saleStore) {
            saleStore.clearAll();
        }
        if (journalStore) {
            journalStore.clearAll();
        }
        if (visitorStore) {
            visitorStore.clearAll();
        }
        if (animalStore) {
            animalStore.clearAll();
        }
        if (calendarStore) {
            calendarStore.clearAll();
        }

        await userStore.save({ customer: parseInt(id, 10) });
        await userStore.getInfo({ forceLoad: true });
        appState.toggleDrawer(false, drawerLevel);
        route('/');
    }

    onClickChooseCustomerDepartment = async e => {
        e.stopPropagation();
        e.preventDefault();
        const { id } = e.target.closest('.customer-department-line').dataset;
        const { drawerLevel = 1 } = this.props;
        const { appState, userStore, saleStore, journalStore, visitorStore, animalStore, calendarStore } = this.props.stores;

        // Clear store data when switching departments
        if (saleStore) {
            saleStore.clearAll();
        }
        if (journalStore) {
            journalStore.clearAll();
        }
        if (visitorStore) {
            visitorStore.clearAll();
        }
        if (animalStore) {
            animalStore.clearAll();
        }
        if (calendarStore) {
            calendarStore.clearAll();
        }

        await userStore.save({ currentCustomerDepartment: parseInt(id, 10) });
        await userStore.getInfo({ forceLoad: true });
        appState.toggleDrawer(false, drawerLevel);
        route('/');
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { menuLinks, menuLinksNotLoggedIn } = this.state;
        const { drawerLevel } = this.props;
        const { appState, userStore, animalStore } = this.props.stores;
        const { isCordova, languageList, language, opts = {}, isDevelopment, view = {}, showAdminFields } = appState;
        const { user, isAdmin, saved, customer, currentCustomers } = userStore;
        const { language: userLanguage } = user;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { animals, owners } = animalStore
        if (!user.id) {
            return (<>
                <div class='bg-light d-flex flex-column justify-content-start pt-4' style='min-height: 100%;'>
                    <MenuList stores={this.props.stores} menus={menuLinksNotLoggedIn} drawerLevel={drawerLevel} />
                    <div class='d-flex flex-row justify-content-center align-items-center mt-3'>
                        {languageList.map(lang => {
                            return (<>
                                <button
                                    type='button'
                                    class={`btn btn-link ${language === lang[0] ? 'text-primary font-weight-bold' : 'text-muted'}`}
                                    onClick={() => appState.setLanguage(lang[0])}
                                >
                                    {lang[2]} {lang[1]}
                                </button>
                            </>);

                        })}
                    </div>
                </div>
            </>);
        }

        return (
            <div class='bg-light d-flex flex-column justify-content-start pt-4' style='min-height: 100%;'>
                {currentCustomers && currentCustomers.length > 1 && <>
                    <div class='mx-4 font-weight-lighter px-3 py-1 text-muted' >
                        <small class='text-uppercase'>
                            <Text id='dyrejournal.your-customers'>Your customers</Text>
                        </small>
                    </div>
                    <div
                        class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} mx-4 mb-3 d-flex flex-column`}
                        style={`
                            font-size: 18px !important;
                            border-radius: 10px;
                        `}
                    >
                        <div class='d-flex flex-column px-3 py-2'>
                            {currentCustomers.map(customer => {
                                return (<>
                                    <div
                                        class={`d-flex rounded-lg px-2 py-1 ${user.customer === customer.id ? 'bg-primary-light' : ''} customer-line`}
                                        data-id={customer.id}
                                        onClick={this.onClickChooseCustomer}
                                    >
                                        {user.customer === customer.id && <>
                                            <i class='fa-solid fa-arrow-right me-2 mt-1' />
                                        </>}
                                        <div>
                                            {customer.name} - {customer.orgNumber}
                                        </div>
                                    </div>
                                </>);
                            })}
                        </div>
                    </div>
                </>}

                {customer.departments && customer.departments.length > 0 && <>
                    <div class='mx-4 font-weight-lighter px-3 py-1 text-muted' >
                            <small class='text-uppercase'>
                                <Text id='dyrejournal.your-customer-departments'>Your Customer Departments</Text>
                            </small>
                        </div>
                        <div
                            class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} mx-4 mb-3 d-flex flex-column`}
                            style={`
                                font-size: 18px !important;
                                border-radius: 10px;
                            `}
                        >
                            <div class='d-flex flex-column px-3 py-2'>
                                {customer.departments.map(department => {
                                    return (<>
                                        <div
                                            class={`d-flex rounded-lg px-2 py-1 ${user.currentCustomerDepartment === department.id ? 'bg-primary-light' : ''} customer-department-line`}
                                            data-id={department.id}
                                            onClick={this.onClickChooseCustomerDepartment}
                                        >
                                            {user.currentCustomerDepartment === department.id && <>
                                                <i class='fa-solid fa-arrow-right me-2 mt-1' />
                                            </>}
                                            <div>
                                                {department.id}: {department.name}
                                            </div>
                                        </div>
                                    </>);
                                })}
                            </div>
                        </div>
                </>}

                {(isDevelopment || opts.showDyrejournal) && <>
                    <div class='mx-4 font-weight-lighter px-3 py-1 text-muted' >
                        <small class='text-uppercase'>
                            <Text id='dyrejournal.clinic'>Your clinic</Text>
                        </small>
                    </div>
                    <div
                        class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} mx-4 d-flex flex-column`}
                        style={`
                            font-size: 18px !important;
                            border-radius: 10px;
                        `}
                    >
                        {/* <div class='position-absolute d-flex flex-nowrap' style='top: 17px; right: 50px;'>
                            <button type='button' class={`btn btn-${view.clinic === 'normal' ? 'primary' : 'outline-secondary'} rounded-pill-left`} onClick={this.selectView} data-type={'normal'}>
                                <i class='fa-duotone fa-rabbit' />
                            </button>
                            <button type='button' class={`btn btn-${view.clinic === 'horse' ? 'primary' : 'outline-secondary'} rounded-none`} onClick={this.selectView} data-type={'horse'}>
                                <i class='fa-duotone fa-horse' />
                            </button>
                            <button type='button' class={`btn btn-${view.clinic === 'cow' ? 'primary' : 'outline-secondary'} rounded-pill-right`} onClick={this.selectView} data-type={'cow'}>
                                <i class='fa-duotone fa-cow' />
                            </button>
                        </div> */}

                        <div class='d-flex flex-row flex-wrap justify-content-center align-items-center'>
                            {animals.length > 0 && animals.map(animal => {
                                const owner = owners && owners.length > 0 ? owners.find(e => e.id === animal.owner) : {};
                                const image = localUtil.getImage({ user: animal });
                                return (<>
                                    <div
                                        class='d-flex flex-column bg-light rounded-lg px-2 py-2 m-2 animal-line'
                                        data-id={animal.id}
                                        onClick={this.onClickViewAnimal}
                                    >
                                        <div class='d-flex flex-row justify-content-center align-items-center'>
                                            <div
                                                class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} rounded-circle d-flex justify-content-center align-items-center font-weight-lighter imageRounded imageRoundedMediumLarge`}
                                                style={`${image ? `background-image: url('${image}'); background-size: cover;` : ''}`}
                                                // style='width: 80px; height: 80px; font-size: 2.5em;'
                                            >
                                                {!image && <>
                                                    <span style='font-size: 33px;'>{animal.name[0]}</span>
                                                 </>}
                                            </div>
                                        </div>
                                        <div class='d-flex justify-content-between'>
                                            <div>{animal.name}</div>
                                            {animal.birth && <div>{animalAge(animal.birth)}</div>}
                                        </div>
                                        <div class='font-weight-lighter'>
                                            ({animal.species}/{animal.breed})
                                        </div>
                                        <div>
                                            {owner?.firstname} {owner?.lastname}
                                        </div>
                                        <div class='font-weight-lighter'>
                                            {owner?.cellphone}
                                        </div>
                                    </div>
                                </>);
                            })}
                        </div>
                    </div>
                </>}

                <MenuList stores={this.props.stores} menus={menuLinks} drawerLevel={drawerLevel} />

                <div class='d-flex flex-row justify-content-center align-items-center mt-3'>
                    {languageList.map(lang => {
                        return (<>
                            <button
                                type='button'
                                class={`btn btn-link ${userLanguage === lang[0] ? 'text-primary font-weight-bold' : 'text-muted'}`}
                                onClick={() => userStore.setLanguage(lang[0])}
                            >
                                {lang[2]} {lang[1]}
                            </button>
                        </>);

                    })}
                </div>
                {isAdmin && <>
                    <div class='d-flex flex-row justify-content-center align-items-center mt-1'>
                        <span
                            class={`badge text-bg-${showAdminFields ? 'danger' : 'light'} font-weight-bold me-2 mt-2`}
                            onClick={this.toggleAdminFields}
                        >Show Admin</span>
                    </div>
                </>}
                <MenuColorLegend class='mt-3' />
                <div class='d-flex flex-row justify-content-center align-items-center mt-3'>
                    <small>
                        Build: {versionData.build}, <span class='font-weight-lighter'>{util.isoDate(versionData.date)}</span>
                    </small>
                </div>
            </div>
        );
    }
}

export default Menu;
